import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function getUserPrinterOptions(
  params: openapi.UserPrinterOptionsQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.UserPrinterOptionsContentOpenapi> {
  return await api.get<openapi.UserPrinterOptionsContentOpenapi>(
    '/user/printer_options/',
    {
      ...requestConfig,
      params,
    },
  );
}
